module.exports = __webpack_public_path__ + "img/3.93b8bb8.png";